import {RegulatoryDataDefaultBox} from "./regulatory-data.default.box";

export const RegulatoryDataBox = RegulatoryDataDefaultBox;
